import type { ISession, ISessionActiveCallback } from '../interface/session';

interface ISessionActiveRecord {
    name: string;
    callback: ISessionActiveCallback;
}

let activeSession: ISession | null = null;
let activeRecords: ISessionActiveRecord[] = [];

const active = () => activeSession;

const setActive = (sessionNew: ISession | null) => {
    activeSession = sessionNew;
    for (const record of activeRecords) {
        record.callback(sessionNew);
    }
};

const subscribeActiveChanged = (callback: ISessionActiveCallback, key?: string): void => {
    activeRecords.push({ name: key ?? `callback-${activeRecords.length}`, callback });
};

const unsubscribeActiveChanged = (callback: ISessionActiveCallback): void => {
    activeRecords = activeRecords.filter(callback_ => callback_.callback !== callback);
};

const subscriber = (subscriberKey: string): ISessionActiveCallback | undefined =>
    activeRecords.find(record => record.name === subscriberKey)?.callback;

export default Object.freeze({
    active,
    setActive,
    subscribeActiveChanged,
    unsubscribeActiveChanged,
    subscriber,
});
